import React from "react";
import Chip from "../Chip";

type PROPS = {
  text: string;
  width?: string;
  onRemove?: () => void;
  maxWidth?: string;
};

const Tag: React.FC<PROPS> = (props) => {
  return (
    <Chip
      text={props.text}
      color="#d1d5db"
      textColor="#000000"
      maxWidth={props.maxWidth}
    />
  );
};

export default Tag;
